<template>
	<div class="container py-5">
        <h2>{{ $t('modelingDetail') }}</h2>
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item">
                    <RouterLink to="/modelings">
                        {{ $t('home') }}
                    </RouterLink>
                </li>
                <li class="breadcrumb-item">{{ data.name }}</li>
            </ol>
        </nav>
		<div v-if="pending">
            <div class="d-flex justify-content-center loading-center">
                <div class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
        </div>
        <div v-else>
            <h3 class="text-center mb-4">{{ $t('inputModel') }}
                <div class="dropdown float-end" v-if="isUserAdmin" >
                    <button class="btn btn-secondary " type="button" id="dropdownMenu2" data-bs-toggle="dropdown" aria-expanded="false">
                         <i class="fa-solid fa-gear"></i>
                    </button>
                    <ul class="dropdown-menu" aria-labelledby="dropdownMenu2">
                        <li> 
                            <RouterLink style="color: black; text-decoration:unset" :to="'/modeling/' + this.$route.params.id + '/import'" >
                                <button class="dropdown-item" type="button">{{ $t('import')}} </button>
                            </RouterLink>
                        </li>
                        <li><button class="dropdown-item" type="button" @click="exportJson()">{{ $t('export')}} </button></li>
                    </ul>
                </div>
            </h3>
            <div class="row mb-4">
                <div class="col-sm-3 mb-4" v-for="(item, i) in datasetList" :key="i">
                    <div class="card text-center">
                        <div class="card-body">
                            <RouterLink style="color: black" :to="'/modeling/' + this.$route.params.id + '/dataset/' + item.id ">
                                <h5 class="card-title">{{ item.name }}</h5>
                            </RouterLink>
                        </div>
                        <ul class="list-group list-group-flush" v-if="assetTypeList.length >= 0"> 
                            <li class="list-group-item" v-for="(item, i) in filteredAssetTypes(assetTypeList, item.id)" :key="i">
                                <RouterLink :to="'/modeling/'+ data.id + '/assettype/' + item.id">
                                    {{ item.name }}
                                </RouterLink>
                            </li>
                        </ul>
                        <div class="card-body" v-if="isUserAdmin">
                            <RouterLink :to="'/modeling/'+ data.id + '/assettypecreate/' + item.id  ">
                                <button class="btn btn-sm btn-light">{{ $t('addAssetType')}}</button>
                            </RouterLink>
                        </div>
                    </div>
                </div>
                <div class="col-sm-3" v-if="isUserAdmin">
                    <div class="card text-center">
                        <div class="card-body">
                            <!-- <h5 class="card-title">{{ $t("addDataset") }}</h5> -->
                            <ul class="list-group list-group-flush" > 
                                <li class="list-group-item" >
                                    <RouterLink :to="'/modeling/'+ data.id + '/datasetcreate'">
                                        <button class="btn btn-sm btn-light">{{ $t('addDataset')}}</button>
                                    </RouterLink>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <h3 class="text-center mb-4">{{ $t('analysisSelection') }}</h3>
            <div class="row mb-4">
                <div class="col-sm-3 mb-4" v-for="(item, i) in forecastList" :key="i">
                    <div class="card text-center">
                        <div class="card-body">
                            <RouterLink style="color: black" :to="'/modeling/' + this.$route.params.id + '/forecast/' + item.id ">
                                <h5 class="card-title">{{ item.name }}</h5>
                            </RouterLink>
                        </div>
                        <ul class="list-group list-group-flush" v-if="selectionList.length >= 0"> 
                            <li class="list-group-item" v-for="(item, i) in filteredSelectionList(selectionList, item.id)" :key="i">
                                <RouterLink :to="'/modeling/'+ data.id + '/selection/' + item.id">
                                    {{ item.name }}
                                </RouterLink>
                            </li>
                        </ul>
                        <div class="card-body" v-if="isUserAdmin">
                            <RouterLink :to="'/modeling/'+ data.id + '/selectioncreate/' + item.id  ">
                                <button class="btn btn-sm btn-light">{{ $t('addSelection')}}</button>
                            </RouterLink>
                        </div>
                    </div>
                </div>
                <div class="col-sm-3" v-if="isUserAdmin">
                    <div class="card text-center">
                        <div class="card-body ">
                            <ul class="list-group list-group-flush" > 
                                <li class="list-group-item" >
                                    <RouterLink :to="'/modeling/'+ data.id + '/forecastcreate'">
                                        <button class="btn btn-sm btn-light">{{ $t('addForecast')}}</button>
                                    </RouterLink>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <h3 class="text-center mb-4">{{ $t('results') }}</h3>
            <table class="table table-bordered" style="border-radius:5px">
                <thead>
                    <tr>
                        <th scope="col">{{ $t('forecastName') }}</th>
                        <th scope="col">{{ $t('selectionName') }}</th>
                        <th scope="col">{{ $t('selectionStartYear') }}</th>
                        <th scope="col">{{ $t('selectionEndYear') }}</th>
                        <th scope="col">{{ $t('createdDate') }}</th>
                        <th scope="col"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, i) in analysisList" :key="i" class="align-middle">
                        <td>
                            {{item.forecastName}}
                        </td>
                        <td>
                            {{item.selectionName}}
                        </td>
                        <td>
                            {{item.selectionStartYear}}
                        </td>
                        <td>
                            {{item.selectionEndYear}}
                        </td>
                        <td>
                            {{this.getCreatedDate(item.createdDate)}}
                        </td>
                        <td class="text-center">
                            <template v-if="item.state === 0 || item.state === 201">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            </template>
                            <template v-else-if="item.state === 500">
                                <span class="text-danger">
                                    {{ $t('resultFailed') }}
                                </span>
                            </template>
                            <template v-else>
                                <RouterLink :to="'/modeling/' + $route.params.id + '/modelingresult/' + item.id">
                                    <button class="btn btn-sm btn-light">{{ $t('detail')}}</button>
                                </RouterLink>
                            </template>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import ModelingApi from "../../api/server/modeling";
import DatasetApi from "../../api/server/dataset";
import AssetTypeApi from "../../api/server/assetType";
import ForecastApi from "../../api/server/forecast";
import SelectionApi from "../../api/server/selection";
import AnalysisApi from "../../api/server/analysis";
import { CheckIfUserIsEditor } from '../../authCache';

export default {
    name: "modelingdetail",
    watch: {
        $route: "requestData",
    },
    mounted() {
        this.requestData();
    },
    methods: {
        exportJson() {
            var request = ModelingApi.modelingExport(this.$route.params.id);
            window.open(request.url);
        },
        confirm() {
            this.requestData();
            this.showSuccessUpload();
            this.showImportModal = false;
        },
        async exportResults(item) {
            var request = AnalysisApi.exportXlsx(this.$route.params.id, item.id);
            window.open(request.url);
        },
        getCreatedDate(date) {
            return moment(date).format("DD.MM.YYYY HH:mm");
        },
        async deleteDataset(dataset) {
            await DatasetApi.datasetDelete(this.$route.params.id, dataset.id);
        },
        filteredAssetTypes(assetTypeList, datasetId) {
            return assetTypeList.filter(a => a.datasetId == datasetId);
        },
        filteredSelectionList(selectionList, forecastId) {
            return selectionList.filter(a => a.forecastId == forecastId);
        },
        async requestData() {
            this.isUserAdmin = await CheckIfUserIsEditor();
            this.data = await ModelingApi.modelingDetail(this.$route.params.id);
            this.datasetList = await DatasetApi.datasetList(this.$route.params.id);
            this.assetTypeList = await AssetTypeApi.assetTypeList(this.$route.params.id);
            this.forecastList = await ForecastApi.forecastList(this.$route.params.id);
            this.selectionList = await SelectionApi.selectionList(this.$route.params.id);

            await this.loadAnalysisList();

            const hasRunning = this.analysisList.some(x => x.state === 0 || x.state === 201);
            if (hasRunning) {
                this.startPollingAnalysis();
            }
            
            this.pending = false;
        },
        async loadAnalysisList() {
            this.analysisList = await AnalysisApi.analysisList(this.$route.params.id, "");

            const hasRunning = this.analysisList.some(x => x.state === 0 || x.state === 201);
            if (!hasRunning && this.pollingHandle) {
                clearInterval(this.pollingHandle);
                this.pollingHandle = null;
            }
        },
        startPollingAnalysis() {
            if (this.pollingHandle) 
                return;
            this.pollingHandle = setInterval(() => {
                this.loadAnalysisList();
            }, 3000);
        },
    },
    notifications: {
        showSuccess: { 
            title: 'success',
            message: 'modelingUpdated',
            type: 'success'
        },
        showSuccessUpload: { 
            title: 'success',
            message: 'importSuccess',
            type: 'success'
        },
    },
    beforeUnmount() {
        if (this.pollingHandle) {
            clearInterval(this.pollingHandle);
        }
    },
    data() {
        return {
            data: {
                name: "",
                id: 0
            },
            datasetList: [],
            assetTypeList: [],
            forecastList: [],
            selectionList: [],
            analysisList: [],
            showImportModal: false,
            pending: true,
            isUserAdmin: false,
            pollingHandle: null
        }
    }
};
</script>